import React, { useCallback, useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'

import Loading from 'components/system/Loading'
import AdminCalendar from 'components/admin/Calendar'
import SlotTheme from 'components/book/slotTheme'
import SearchBox from 'components/search/SearchBox'
import EditDayDialog from 'components/admin/EditDayDialog'
import useCalendar from 'components/hooks/useAdminCalendar'
import GlobalLoading from 'components/system/GlobalLoading'

import bookActions from 'store/modules/booking'
import bookSelectors from 'store/selectors/booking'
import projectSelectors from 'store/selectors/project'
import routerSelectors from 'store/selectors/router'
import routerActions from 'store/modules/router'
import adminActions from 'store/modules/admin'
import adminSelectors from 'store/selectors/admin'

const useStyles = makeStyles(theme => {
  const slotTheme = SlotTheme(theme)
  return {
    root: {
      marginBottom: theme.spacing(4),
    },
    keyContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
    },
    calendarContainer: {

    },
    searchContainer: {
      marginBottom: theme.spacing(2),
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    },
    searchBox: {
      width: '400px',
    },
    blockedSlot: {
      width: '30px',
      height: '10px',
      marginLeft: theme.spacing(4),
      ...slotTheme.blockedSlot
    },
    reservedSlot: {
      width: '30px',
      height: '10px',
      marginLeft: theme.spacing(4),
      ...slotTheme.reservedSlot
    },
    partiallyBookedSlot: {
      width: '30px',
      height: '10px',
      marginLeft: theme.spacing(4),
      ...slotTheme.partiallyBookedSlot
    },
    bookedSlot: {
      width: '30px',
      height: '10px',
      marginLeft: theme.spacing(4),
      ...slotTheme.bookedSlot
    },
  }
})

const BookingFormCalendarSearch = ({

}) => {
  const dispatch = useDispatch()

  const {
    id,
  } = useSelector(routerSelectors.params)

  const searchResults = useSelector(adminSelectors.searchResults)
  const searchLoading = useSelector(adminSelectors.search.loading)

  const onSearch = useCallback((query) => {
    dispatch(adminActions.search({
      id,
      query,
    }))
  }, [
    id,
  ])

  const onSearchChoose = useCallback((record) => {
    dispatch(adminActions.openSearch({
      project: record.data.project,
      bookingform: record.data.bookingform,
      id: record.data.id,
    }))
  }, [
    id,
  ])

  const onSearchReset = useCallback((query) => {
    dispatch(adminActions.setSearchResults([]))
  }, [])

  return (
    <SearchBox
      results={ searchResults }
      loading={ searchLoading }
      onSearch={ onSearch }
      onChoose={ onSearchChoose }
      onReset={ onSearchReset }
    />
  )

}

const BookingFormCalendar = ({

}) => {

  const classes = useStyles()
  const dispatch = useDispatch()

  const [ editDay, setEditDay ] = useState(null)
  const {
    id,
    date,
  } = useSelector(routerSelectors.params)

  const project = useSelector(projectSelectors.currentProjectId)
  const config = useSelector(bookSelectors.config)

  const onClickSlot = useCallback((slot) => {
    dispatch(bookActions.setSlot(slot))
    dispatch(routerActions.navigateTo('admin.bookingforms.edit.slot', {
      id,
      date: slot.date,
      block_id: slot.block_id,
      slot_id: slot.id,
    }))
  }, [
    id,
  ])

  const calendar = useCalendar({
    project,
    bookingform: id,
    config,
  })

  const onEditDay = useCallback((day) => {
    setEditDay(day)
  }, [])

  const onSubmitEditDay = useCallback(async (data) => {
    const result = await dispatch(adminActions.updateDayOverride({
      project,
      bookingform: id,
      date: editDay.date,
      data,
    }))
    if(result) {
      setEditDay(null)
      calendar.reload()
    }
  }, [
    project,
    id,
    editDay,
  ])

  const onDeleteDay = useCallback(async () => {
    const result = await dispatch(adminActions.resetDayOverride({
      project,
      bookingform: id,
      date: editDay.date,
    }))
    if(result) {
      setEditDay(null)
      calendar.reload()
    }
  }, [
    project,
    id,
    editDay,
  ])

  const onCancelEditDay = useCallback(() => {
    setEditDay(null)
  }, [])

  useEffect(() => {
    dispatch(bookActions.loadCalendarConfig({
      project,
      bookingform: id,
    }))
  }, [
    project,
    id,
  ])
  
  return (
    <>
      <AdminCalendar
        calendar={ calendar }
        onClickSlot={ onClickSlot }
        onEditDay={ onEditDay }
      >
        <div className={ classes.searchContainer }>
          <div className={ classes.searchBox }>
            <BookingFormCalendarSearch />
          </div>
        </div>
      </AdminCalendar>
      {
        editDay && (
          <EditDayDialog
            day={ editDay }
            onSubmit={ onSubmitEditDay }
            onCancel={ onCancelEditDay }
            onDeleteDay={ onDeleteDay }
          />
        )
      }
      {
        calendar.loading && (
          <GlobalLoading />
        )
      }
    </>
  )
}

export default BookingFormCalendar